module.exports = "<h4 id=\"appbooster\">Appbooster</h4>\n<p><strong>Проект:</strong> Набор систем для мобильного маркетинга и продвижения в сторах</p>\n<p><strong>Описание:</strong> Системы для продвижения мобильных приложений</p>\n<p><strong>Языки:</strong>​ Ruby</p>\n<p><strong>Позиция:</strong> Developer</p>\n<p><strong>Ответственность:​</strong></p>\n<ul>\n<li>Разработка и поддержка апи сервисов компании</li>\n<li>Скрапинг данных из разных источников (написал несколько сервисов скрапинга)</li>\n<li>Прокси сервисы (разработал и поддерживаю балансировщики нагрузки)</li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/appbooster_ru.md
// module id = jQlH
// module chunks = 1